import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { chipColors } from '../../lib/contrast';

type EventKind = 'RACE' | 'TOURNAMENT' | 'HANGOUT';

type Props = {
    kind: EventKind;
};

/**
 * Chip event kind
 */
export function SttChipEventKind({ kind }: Props): React.ReactElement {
    const { t } = useTranslation();

    const color: Record<EventKind, string> = {
        RACE: '#3186a7',
        TOURNAMENT: '#a341bb',
        HANGOUT: '#f35b77',
    };

    return (
        <>
            {kind && (
                <Chip
                    size="small"
                    label={t(`eventKinds.${kind.toLowerCase()}`)}
                    style={{ ...chipColors(color[kind]) }}
                />
            )}
        </>
    );
}
